import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import styled from 'styled-components';

export const StyledAssignTaskDrawer = styled.div`
  .main-panel {
    display: flex;
    flex-direction: column;
    gap: 24px;
    .no-input-explain {
      .input-explain {
        display: none;
      }
    }
  }
`;
